export default {
    variants: {
        localeSelector: ({theme}) => ({
            list: {
                // disable base styles
                boxShadow: null,
                minW: null,
                py: null,
                borderRadius: null,
                // custom styles
                minWidth: {base: '21.4375rem', lg: '8.125rem'},
                borderColor: {base: 'stokkeGray.mid', lg: 'stokkeGray.bright'}
            },
            item: {
                // disable base styles
                px: null,
                py: null,
                _active: {
                    bg: null
                },
                _focus: {
                    bg: null
                },
                _expanded: {
                    bg: null
                },
                // custom styles
                ...theme.textStyles['Badge Regular'],
                justifyContent: 'space-between',
                paddingInline: {base: 4, lg: 3},
                paddingBlock: {base: 4, lg: 2},
                '@media(pointer: fine)': {
                    _focus: {
                        bg: 'stokkeGray.bright'
                    }
                }
            }
        })
    }
}
